import { useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import { snackActions } from "../utils/SnackbarUtils";
import { useEffect } from "react";

export const useLoginId = () => {
  const [searchParams] = useSearchParams();
  if (searchParams.get("loginId"))
    Cookies.set("loginId", searchParams.get("loginId") ?? "");
  const loginId = Cookies.get("loginId");
  useEffect(() => {
    if (!loginId) snackActions.error("ازمسیر اشتباه وارد این صفحه شده اید");
  }, [loginId]);

  return { loginId };
};
